import { DocumentChatsBackref } from "@/components/common/DocumentChatsBackref";
import { DocPanel, type DocPanelTab } from "@/components/shared/DocPanel";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export function DocViewModal({ tab, onClose }: { tab: DocPanelTab | null; onClose: () => void }) {
  return (
    <Dialog open={Boolean(tab)} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent showClose={false} className="h-screen w-screen max-w-none gap-0 overflow-hidden rounded-none border-0 p-0">
        <DialogTitle className="sr-only">Document viewer</DialogTitle>
        {tab ? (
          <div className="flex h-full min-w-0 flex-col">
            <DocumentChatsBackref documentId={tab.documentId} onClose={onClose} />
            <div className="min-h-0 min-w-0 flex-1">
              <DocPanel tab={tab} onClose={onClose} />
            </div>
          </div>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
